import React from 'react';
import { StepBar } from '../../ui';
import { formatCredits } from '../../../utils/credits';

/**
 * Step 2's StepBar: the criteria in one line — where, how soon, how many
 * components and what starting will cost — and Start discovery. Until the
 * lead time is in, the line says so instead of the button explaining itself.
 * A delivery location is optional: without one the line says so gently and
 * Start stays on.
 */
export interface CriteriaStepBarProps {
  location: string;
  leadTimeLabel?: string;
  components: number;
  /** Credits per component; null when the meter could not be read. */
  rate: number | null;
  readOnly: boolean;
  starting: boolean;
  onBack: () => void;
  onStart: () => void;
}

export const NO_DELIVERY_HINT = 'no delivery location — suppliers quote without one';

export const CriteriaStepBar: React.FC<CriteriaStepBarProps> = ({
  location,
  leadTimeLabel,
  components,
  rate,
  readOnly,
  starting,
  onBack,
  onStart,
}) => {
  const cost = rate === null ? '' : ` (${formatCredits(components * rate)} credits)`;
  const count = `${components} ${components === 1 ? 'component' : 'components'}${cost}`;
  const missing = readOnly || leadTimeLabel ? null : 'add lead time to start';
  const noDelivery = !readOnly && !missing && !location.trim();
  const known = [location.trim(), leadTimeLabel].filter(Boolean) as string[];
  const summary = (
    <>
      {known.length > 0 && `${known.join(' · ')} · `}
      <strong className="font-semibold text-ink">{count}</strong>
      {missing && (
        <>
          {' · '}
          <span className="text-warn-ink">{missing}</span>
        </>
      )}
      {noDelivery && (
        <>
          {' · '}
          <span className="text-ink-muted">{NO_DELIVERY_HINT}</span>
        </>
      )}
    </>
  );
  return (
    <StepBar
      stepLabel="Step 2 · Sourcing criteria"
      summary={summary}
      onBack={onBack}
      cta={{
        label: readOnly ? 'Continue to discovery' : 'Start discovery',
        onClick: onStart,
        disabled: !readOnly && Boolean(missing),
        loading: starting,
        loadingLabel: 'Starting…',
      }}
    />
  );
};

export default CriteriaStepBar;
